import React from "react";

import {
  APPLIED_ONBOARDING_LANDING_EXPERIMENT_VARIANT,
  TOI_ONBOARDING_LANDING_EXPERIMENT,
} from "../../../constants";
import TOIAboundComparisonLandingPage from "./TOIAboundComparisonLandingPage";
import TOIUpdatedLandingPage from "./TOIUpdatedLandingPage";

function TOILandingExperiment() {
  if (
    APPLIED_ONBOARDING_LANDING_EXPERIMENT_VARIANT ===
    TOI_ONBOARDING_LANDING_EXPERIMENT.ABOUND_COMPARISON
  ) {
    return <TOIAboundComparisonLandingPage />;
  }

  return <TOIAboundComparisonLandingPage />;
}

export default TOILandingExperiment;
